import { criterioDoSelo, tituloDoTipo } from '../destaques-modelo';
import RegrasDosDestaquesDaCultura from './RegrasDosDestaquesDaCultura';

/**
 * DEX-02: o (i) da lista explica os três destaques, na ordem dos selos. Galeria e Realização com o critério que o
 * perfil já mostra; a Cultura com as regras da versão atual do sistema (o mesmo texto do (i) do perfil).
 */
export default function ExplicacaoDosDestaques({ ciclo }: { ciclo: string }) {
  return (
    <div className="flex flex-col gap-3">
      <p className="m-0">
        <b>{tituloDoTipo('galeria')}:</b> {criterioDoSelo('galeria', ciclo)}
      </p>
      <div>
        <p className="m-0 mb-1">
          <b>{tituloDoTipo('cultura')}:</b>
        </p>
        <RegrasDosDestaquesDaCultura />
      </div>
      <p className="m-0">
        <b>{tituloDoTipo('realizacao')}:</b> {criterioDoSelo('realizacao', ciclo)}
      </p>
    </div>
  );
}
